import { render } from "./MenuDetail.vue?vue&type=template&id=0475df13&scoped=true&ts=true"
import script from "./MenuDetail.vue?vue&type=script&lang=ts"
export * from "./MenuDetail.vue?vue&type=script&lang=ts"

import "./MenuDetail.vue?vue&type=style&index=0&id=0475df13&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0475df13"]])

export default __exports__